module.exports = __webpack_public_path__ + "static/media/68.11ae815a.png";